import React, {useState} from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

const Section7 = ({url}) => {

const [active, setActive] = useState(null);

const faqs = [
  {
    q: "What are AI development services?",
    a: "AI development services involve designing, building, and deploying custom artificial intelligence solutions tailored to a business's specific operations and goals. This includes AI integration with existing systems, business process automation, custom model development, machine learning pipelines, and intelligent chatbot development. Unlike off-the-shelf AI tools, these solutions are built around your data and workflows.",
  },
  {
    q: "What is the difference between AI automation and traditional automation?",
    a: "Traditional automation follows fixed, rule-based instructions and cannot handle variability or unstructured data. AI automation adds intelligence, allowing systems to interpret unstructured inputs, make context-aware decisions, and improve over time. This enables handling of exceptions and edge cases that would otherwise require human intervention.",
  },
  {
    q: "How long does an AI development project take?",
    a: "Timelines depend on scope and complexity. A focused automation workflow or chatbot can be delivered in 4 to 8 weeks, while a custom AI model or multi-agent system typically requires 3 to 6 months, including data preparation, development, testing, and integration. Timelines are finalized during the feasibility and scoping phase.",
  },
  {
    q: "What AI platforms and technologies does ExD Digital work with?",
    a: "ExD Digital primarily builds on the OpenAI ecosystem, including GPT-4 and Assistants API, and also works with Google Gemini, Anthropic Claude, and open-source models via Hugging Face. The approach is model-agnostic, selecting the best technology based on your requirements, security constraints, and long-term maintainability.",
  },
  {
    q: "Is our data safe when using AI development services?",
    a: "Data security is addressed at the architecture stage. Depending on requirements, solutions include private API configurations, on-premise deployments, data anonymization pipelines, and strict access controls. For strict data residency needs, systems can be built entirely within your infrastructure using open-source models.",
  },
  {
    q: "Do we need large amounts of data to benefit from AI?",
    a: "Not necessarily. Many AI integrations using existing large language models require little to no training data. Custom model development does require sufficient domain-specific data, which is assessed during feasibility. Data preparation can also be included as part of the project scope.",
  },
  {
    q: "What is the difference between AI automation and RPA?",
    a: "Robotic Process Automation (RPA) automates structured, rule-based tasks by mimicking human interactions with software. AI automation goes further by handling unstructured data, making decisions, and adapting to variability. Depending on the problem, both approaches can be used independently or combined.",
  },
  {
    q: "How much do AI development services cost?",
    a: "Costs vary based on complexity, data requirements, and integration depth. Custom AI solutions are scoped individually, with full cost transparency provided during the scoping phase before any commitment is made.",
  },
  {
    q: "What industries does ExD Digital deliver AI development services for?",
    a: "ExD Digital has delivered AI solutions across financial services, e-commerce, logistics, healthcare operations, professional services, and SaaS businesses. Cross-industry experience allows applying proven patterns from one domain to another.",
  },
  {
    q: "What makes a good AI development company for small businesses?",
    a: "The best AI development partner starts with problem definition rather than technology, assesses data readiness before committing to scope, and builds solutions that are maintainable so the business can operate them independently after delivery.",
  },
  {
    q: "What is agentic AI and does my business need it?",
    a: "Agentic AI refers to systems that can plan, reason, use tools, and execute multi-step tasks autonomously. Unlike chatbots, these systems can act independently. Most businesses do not need agentic AI unless they have complex, multi-step workflows where human oversight is a bottleneck.",
  },
  {
    q: "How do I know if my business is ready for AI development?",
    a: "A business is typically ready if it has a clearly defined repetitive process, sufficient historical data (6–12 months), and a specific outcome it wants to achieve. A discovery and feasibility phase helps determine the right starting point.",
  },
  {
    q: "What makes ExD Digital different from other AI development companies?",
    a: "ExD Digital focuses on problem definition and data readiness before selecting technology, includes proof-of-concept validation for complex solutions, and builds systems with maintainability and operational independence as core requirements.",
  },
];

  return (

    <section className="home-section-7">
       {/* FAQ */}
        <div className="faq-section">
        <div className="container">

            <h2 className="text-center">Frequently Asked Questions</h2>

            <div className="faq-list">
            {faqs.map((item, i) => (
                <div
                key={i}
                className={`faq-item ${active === i ? "active" : ""}`}
                onClick={() => setActive(active === i ? null : i)}
                >
                <div className="faq-question">
                    <span>{item.q}</span>
                    <FontAwesomeIcon icon={faChevronDown} />
                </div>

                <div className="faq-answer">
                    {item.a}
                </div>
                </div>
            ))}
            </div>

        </div>
        </div>

        {/* CTA */}
        {/* <div className="cta-section">
        <div className="container">
            <div className="cta-box text-center">

            <h2>Now Hire the Right Employees with <br/> AI Power, not ManPower</h2>

            <button className="btn btn-light">Lets Get Started</button>

            </div>
        </div>
        </div> */}
    </section>
  );
};

export default Section7;